import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applyPrizeBoth,
} from './../../../actions/FilterActions';
import common from '../../../common';
import config from './../../../config';
import OutsideNotifier from '../../../OutsideNotifier';
import { Scrollbars } from 'react-custom-scrollbars';
import {
    getWildCardStatus,
    getBoosterStatus,
} from "../../../helper-common";

class PrizeFilterWeb extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dropDownActive: false,
            priceLable: this.props.trans.unlimited ? this.props.trans.unlimited : "unlimited"
        }

    }
    toggleDrpDown(val) {
        if (val == false) {
            this.setState({
                dropDownActive: false
            })
        } else {
            this.setState({
                dropDownActive: !this.state.dropDownActive
            })
            if (!this.state.dropDownActive) {
                // common.customTracking('Price - Filters');
            }
        }
    }

    onPriceFilterClick = (e, priceID, el) => {
        e.stopPropagation();
        let currentFixture = { "GDID": 0 };
        if (this.props.userSpecificFixtures && this.props.userSpecificFixtures.length) {
            currentFixture = this.props.userSpecificFixtures[(this.props.currentActiveFixture || 0)];
        }

        const {
            GDID
        } = currentFixture;

        const limitlessStatus = getBoosterStatus(this.props.teamData, GDID || 0);

        this.setState({
            priceLable: el.label
        })
        if (limitlessStatus == config.limitlessBoosterStatus["usedInCurrentTemp"] && priceID == 101) {
            this.props.applyPrizeBoth(102);
        } else {
            this.props.applyPrizeBoth(priceID);
        }
        common.customTracking('Select Price filter - ' + (config.priceTrans[priceID] ? config.priceTrans[priceID] : el.label), common.getPageName());
        this.toggleDrpDown()


    };

    resetFilter = (e, priceId, el) => {
        e.stopPropagation();

        this.setState({
            priceLable: el.label
        })
        this.props.applyPrizeBoth(priceId);
    }

    getPriceLable = (id, from) => {
        var priceLable = ""
        if (id >= 100) {
            priceLable = this.props.trans[config.priceFilterObj[id].label] ? this.props.trans[config.priceFilterObj[id].label] : config.priceFilterObj[id].label;
        } else if (id < 100) {
            priceLable = config.priceFilterObj[id].label ? (from == "label" ? "" : (this.props.trans.upTo ? this.props.trans.upTo : "upTo")) + " " + config.priceFilterObj[id].label + this.props.trans.million : "m"
        } else {
            priceLable = config.priceFilterObj[id].label
        }

        if (from == "label" && id == 100) {
            priceLable = this.props.trans.filterByPrice ? this.props.trans.filterByPrice : "Price"
        }
        return priceLable;
    }

    render() {
        const className = common.makeClasses({
            'si-selectBoxes': true,
            'si-active': this.state.dropDownActive,
        });
        const defaultPrice = { id: 100, label: 'Unlimited', min: 0, max: 100, }
        const selectedClass = common.makeClasses({
            "si-dropdown-btn": true,
            "si-flexBox": true,
            "si-selected-option": this.props.priceFilterSelected[0] != 100
        })
        return <div className={ className }>
            <OutsideNotifier
                handler={ () => this.toggleDrpDown(false) }>
                <div className={ selectedClass } onClick={ (e) => { e.stopPropagation(); this.toggleDrpDown() } }>
                    <span className="si-select-val">{ this.getPriceLable(this.props.priceFilterSelected[0], "label") }</span>
                    { this.props.priceFilterSelected[0] == 100 ? null : <span className="si-close" onClick={ (e) => { e.stopPropagation(); this.resetFilter(e, defaultPrice.id, defaultPrice) } }>
                        <i className="icon-ucl-close"></i>
                    </span> }
                    <i className="icon-ucl-position"></i>
                </div>

                { this.state.dropDownActive ? <ul className="si-dropdown-options">
                    <Scrollbars autoHide>
                        { this.props.priceFilter.map(el => {
                            const className = common.makeClasses({
                                'si-active': this.props.priceFilterSelected.indexOf(el.id) > -1,
                                'si-display-none': el.id == 102
                            });
                            return <li className={ className } val={ el.id } key={ el.id } onClick={ (e) => {
                                this.onPriceFilterClick(e, el.id, el)
                            } }>
                                <span>{ this.getPriceLable(el.id) }</span>
                            </li>
                        }) }
                    </Scrollbars>
                </ul> : "" }
            </OutsideNotifier>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        priceFilter: state.formationData.priceFilter,
        priceFilterSelected: state.formationData.playerFilters.priceFilterSelected,
        teamData: state.formationData.teamData,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applyPrizeBoth: (priceID) => dispatch(applyPrizeBoth(priceID)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrizeFilterWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PrizeFilterWeb.js